import Kicker from "components/Kicker"
import { fmobile, fresponsive, ftablet } from "library/fullyResponsive"
import styled, { css } from "styled-components"
import colors from "styles/colors"
import textStyles from "styles/text"
import Steps from "./Steps"

export default function HowItWorks() {
	return (
		<Wrapper>
			<Kicker barcodes="double" variant="long">
				How it Works
			</Kicker>
			<Title>
				Launch <Strong>Quickly</Strong>. <Strong>Scale</Strong> Effortlessly.
			</Title>
			<Paragraph>
				Onboard your team and start driving efficiency in record time.
			</Paragraph>
			<Steps />
		</Wrapper>
	)
}

const Wrapper = styled.div`
	${fresponsive(css`
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		padding: 111px 0 136px;
	`)}

	${ftablet(css`
		padding-top: 174px;
	`)}

	${fmobile(css`
		text-align: left;
		align-items: flex-start;
		padding: 60px 17px 20px;
		margin-bottom: unset;
	`)}
`
const Title = styled.div`
	${fresponsive(css`
		${textStyles.h3uncapped};
		max-width: 455px;
		margin: 19px 0;
	`)}

	${fmobile(css`
		${textStyles.h5};
		max-width: 243px;
	`)}
`
const Strong = styled.strong`
	color: ${colors.blue2};
`
const Paragraph = styled.div`
	${fresponsive(css`
		${textStyles.p2};
		color: ${colors.grey3};
		max-width: 445px;
		margin-top: -5px;
	`)}

	${ftablet(css`
		${textStyles.p1};
		max-width: 375px;
	`)}

	${fmobile(css`
		${textStyles.p2};
		max-width: 250px;
	`)}
`
